import { GetUserAcceptanceTerm } from '../../interfaces/operational-limit/operational-limit.interface';
import { OperationalLimitAction } from './operational-limit.action';

export class OperationalLimitState {
  public value: GetUserAcceptanceTerm;
  public pending: boolean;
  public error: any;
}

export const initialOperationalLimitState: OperationalLimitState = {
  value: null,
  pending: false,
  error: null,
};

export function OperationalLimitReducer(
  state: OperationalLimitState = initialOperationalLimitState,
  action: any
): OperationalLimitState {
  switch (action.type) {
    /**
     * Recebe se o cliente já aceitou o LO;
     */
    case OperationalLimitAction.getAcceptanceTerm:
      return { ...state, pending: true, error: null };

    case OperationalLimitAction.getAcceptanceTermSuccess:
      return { ...state, ...action.payload, pending: false, error: null };

    case OperationalLimitAction.getAcceptanceTermError:
      return { ...state, ...action.payload, pending: false, error: action.payload }

    /**
     * Salva o aceite do LO
     */
    case OperationalLimitAction.acceptTerm:
      return { ...state, pending: true, error: null };

    case OperationalLimitAction.acceptTermSuccess:
      return { ...state, ...action.payload, pending: false, error: null };

    case OperationalLimitAction.acceptTermError:
      return { ...state, pending: false, error: action.payload };

    /**
     * Rejeita o aceite do LO
     */
    case OperationalLimitAction.rejectTerm:
      return { ...state, pending: true, error: null };

    case OperationalLimitAction.rejectTermSuccess:
      return { ...state, ...action.payload, pending: false, error: null };

    case OperationalLimitAction.rejectTermError:
      return { ...state, pending: false, error: action.payload };

    default:
      return state;
  }
}
